import { call, put, takeLatest } from 'redux-saga/effects';

import { refusalPdf } from '../../services/API/refusal';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(refusalPdf);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* refusalPdfSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
